import { http } from '@/lib/http';
import { useMutation } from '@tanstack/react-query';
import { useToast } from './use-toast';

export const useUpload = () => {
  const toast = useToast();
  return useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append('image', file);

      const res = await http.post<{ file: { path: string } }>(
        '/uploads/images',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );
      return res.data.file.path;
    },

    onError: (error) => {
      toast.error(error?.message ?? 'Algo deu errado!');
    },
  });
};
